<template>
    <div v-if="booted">
        <connection-monitor></connection-monitor>

        <div class="row">
            <div class="col-md-6 col-md-offset-3 text-center">
                <search-form></search-form>
                <br>
                <search-options></search-options>
                <br>
            </div>
        </div>

        <hr>

        <!--<records-table :records="records" :counts="counts"-->
        <!--@record-selected="showRecord($event)"-->
        <!--:class="`transition-width ${splitView ? 'left-pane' : 'full-pane'}`">-->
        <!--</records-table>-->

        <div class="full-pane">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import RecordsTable from './views/RecordsTable.vue'
    import SearchForm from './components/Search/SearchForm.vue'
    import SearchOptions from './components/Search/SearchOptions.vue'
    import ConnectionMonitor from './components/Support/ConnectionMonitor.vue'
    import initialiseStore from './support/initialiseStore'

    export default {
        components: {
            SearchOptions,
            RecordsTable,
            SearchForm,
            ConnectionMonitor,
        },

        data() {
            return {
                booted: false,
            };
        },

        mounted() {
            initialiseStore(this.$store);
            this.booted = true;
        },
    }
</script>

<style scoped>

</style>
